var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.logOut()}}},[_vm._v("Logout "),_c('img',{staticClass:"icon",attrs:{"src":require("../assets/logout.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }